export * from './Partner'
export { default } from './Partner'
